import { helper as buildHelper } from '@ember/component/helper';

export const formatNumber = ([value]) => {
  try {
    return Number(value).toLocaleString('en-US');
  } catch (e) {
    return value;
  }
};

export default buildHelper(formatNumber);
